import { Component, Input, forwardRef, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {
  MatDatepicker,
  MatDatepickerInputEvent,
} from '@angular/material/datepicker';

@Component({
  selector: 'app-datepicker',
  templateUrl: './app-datepicker.component.html',
  styleUrls: ['./app-datepicker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppDatepickerComponent),
      multi: true,
    },
  ],
})
export class AppDatepickerComponent implements ControlValueAccessor {
  @Input() label = '';
  @Input() required = false;
  @Input() disabled = false;
  @Input() name: string = '';
  @Input() id: string = '';
  @Input()
    set max(value: Date | string | null) {
      if (!value) {
        this._max = null;
        return;
      }

      if (value instanceof Date) {
        this._max = value;
        return;
      }

      // value string esperado: YYYY-MM-D
      const parsed = new Date(`${value}T00:00:00`);
      this._max = Number.isNaN(parsed.getTime()) ? null : parsed;
    }

    private _max: Date | null = null;   

    get max(): Date | null {
      return this._max;
    }

  @ViewChild('pickerSesDate') datepicker!: MatDatepicker<Date>;

  value: Date | null = null;

  onChange: (value: Date | null) => void = () => {};
  onTouched: () => void = () => {};

  writeValue(value: Date | null): void {
    this.value = value;
  }
  registerOnChange(fn: (value: Date | null) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onDateChange(event: MatDatepickerInputEvent<Date>) {
    this.value = event.value;
    this.onChange(this.value);
  }

  setToday() {
    const today = new Date();
    this.value = today;
    this.onChange(this.value);
    this.datepicker.select(today);
    this.datepicker.close();
  }
}